// components/hauler/GateNotice.js
// Informational notices for crew/trailer/capacity requirements.
// Per IC compliance: notices inform, they do not penalize.

import React from "react";

const COLORS = {
  bg: "rgba(242,151,39,.08)",
  border: "rgba(242,151,39,.4)",
  text: "var(--hl-amber)",
  body: "var(--hl-text)",
};

export default function GateNotice({ kind, children }) {
  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.border}`,
      borderRadius: 12,
      padding: "10px 12px",
      marginBottom: 10,
    }}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: COLORS.text, textTransform: "uppercase", marginBottom: 4 }}>
        {kind}
      </div>
      <div style={{ fontSize: 12, color: COLORS.body, lineHeight: 1.4 }}>
        {children}
      </div>
    </div>
  );
}

// Crew threshold mirrors src/pages/DriverScreen.js:325 (canonical).
export function crewRequiredCount(job) {
  if (job?.size === "Full") return 2;
  if (job?.size === "ThreeQ") return 1;
  return 0;
}
